<template>
  <div class="home">
    <navigaTion></navigaTion>
      <!-- 顶部 -->
    <div class="header">
      <div class="banner">
        <!-- 顶部左侧 -->
          <div class="headerLeft">
            <img src="@/assets/home/Préstamos efectivo.png" alt="" width="475px">
            <div class="line"></div>
            <ul>
              <div class="title">
                <span>Ventajas del producto</span>
                <img src="@/assets/home/curve.png" alt="" width="50px" height="48px">
              </div>
              <li>> Cero umbral,sin garantía.</li>
              <li>> Verificación rápida sin necesitar espear mucho tiempo.</li>
              <li>> Verificación en línea las 24 horas,los préstamos se realizan en cualquier lugar y en cualquier momento.</li>
              <li>> Seguridad de la información, múltiples protecciones de privacidad para evitar la revelación.</li>
            </ul>
            <div class="HeaderBottom">
              <!-- 顶部左侧下载图片 -->
              <a target="_blank" href="https://boutiqueprice.com/a">
                <img src="@/assets/home/download.png" alt="">
              </a>
              <a target="_blank" href="https://boutiqueprice.com/i">
                <img src="@/assets/home/IOSDownload.png" alt="">
              </a>
            </div>
          </div>
          <!-- 顶部右侧图 -->
          <div class="headerRight">
            <img src="@/assets/home/header.png" alt="">
          </div>
      </div>
    </div>
      <!-- 介绍 -->
    <div class="introduce">
      <div class="banner">
        <h2>Pide prestado y devuelve en cualquier momento con una cuota revolvente</h2>
        <ul>
          <div class="dashed"></div>
          <li>
            <img src="@/assets/home/record.png" alt="">
            <div class="text">
              <h4>Registrarse y verificar</h4>
              <p>Debe registrarse y completar la información requerida para terminar la verificación.</p>
            </div>
          </li>
          <li>
            <img src="@/assets/home/proving.png" alt="">
            <div class="text">
              <h4>Solicitar préstamos</h4>
              <p>Puede elegir el monto y el plazo de préstamos de acuerdo con sus necesidades y agregar una cuenta para recibir el dinero. Puede solicitar préstamos y ver los resultados de las verificaciones..</p>
            </div>
          </li>
          <li>
            <img src="@/assets/home/fast.png" alt="">
            <div class="text">
              <h4>Obtención de préstamos</h4>
              <p>Completamos el proceso de verificación en 3 minutos. Si se aprueba, el dinero se acreditará de inmediato.</p>
            </div>
          </li>
          <li>
            <img src="@/assets/home/repayment.png" alt="">
            <div class="text">
              <h4>Pagar el préstamo a tiempo</h4>
              <p>Para aumentar el límite de crédito y evitar multas, debe pagar a tiempo los préstamos antes de las fechas de vencimiento.</p>
            </div>
          </li>
          <li>
            <img src="@/assets/home/circulate.png" alt="">
            <div class="text">
              <h4>Volver a pedier préstamos</h4>
              <p>Nos complace ayudarlo a alcanzar la vida de su sueño y esperamos poder brindarle ayuda nuevamente.</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 联系方式 -->
    <div class="contact">
      <div class="content">
        <!-- 联系方式左侧标题 -->
        <div class="contactLeft">Atención al cliente</div>
        <div class="contactRight">
          <!-- 联系方式右侧手机号等 -->
          <ul>
            <li>
              <div class="iconLeft">
                <img src="@/assets/home/phone.png" alt="">
              </div>
              <div class="iconRight">
                <h6>Llame a la línea directa de servicio al cliente</h6>
                <p>+52 5589578400</p>
              </div>
            </li>
            <!-- <li>
              <div class="iconLeft">
                <img src="@/assets/home/WeChat.png" alt="">
              </div>
              <div class="iconRight">
                <h6>Whats App</h6>
                <p>+52 5574067350</p>
              </div>
            </li> -->
            <li>
              <div class="iconLeft">
                <img src="@/assets/home/mailbox.png" alt="">
              </div>
              <div class="iconRight">
                <h6>Correo electrónico de servicio al cliente</h6>
                <p>contacto@boutiqueprice.com</p>
              </div>
            </li>
            <!-- <li>
              <div class="iconLeft">
                <img src="@/assets/home/phone.png" alt="">
              </div>
              <div class="iconRight">
                <h6>Hotline de quejas</h6>
                <p>+52 5589578400</p>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="banner">
        <!-- 底部左侧logo -->
        <a href="#" class="logo" @click="goHome">
          <img src="@/assets/home/logo2.png" alt="">
          <span>Préstamo Boutique</span>
        </a>
        <!-- 底部地址 -->
        <div class="address">
          <h3>Dirección</h3>
          <p> Rio Churubusco, Colonia Xoco, Alcaldía Benito Juárez, <br>
            CP 03330 Ciudad de México
          </p>
          <!-- 取消精品账户 -->
          <div class="cancelBoutique" @click="$router.push({name: 'cancelBoutique'})">
            <span>
              Cancelar la cuenta de Boutique
            </span>
          </div>
          <a @click="goAgreement('user')" > {{userServiceAgreement}} </a>
          <a @click="goAgreement('Privacy')">  {{privacyPolicy}} </a>
        </div>
        <!-- 底部右侧gp下载 -->
        <div class="footerDownload">
          <a target="_blank" href="https://boutiqueprice.com/a">
            <img src="@/assets/home/download.png" alt="">
          </a>
          <a target="_blank" href="https://boutiqueprice.com/i">
            <img src="@/assets/home/IOSDownload.png" alt="">
          </a>
        </div>
      </div>
      <!-- 底部下方版权号 -->
      <div class="bottom">Copyright @ 2023 NDM&ECOMERCE HOLDING SAPI DE CV SOFOM ENR. All Rights Reserved</div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      userServiceAgreement: '<Acuerdo de Servicio al Usuario>',
      privacyPolicy: '<Política de Privacidad>'
    }
  },
  created () {
    window.scroll(0, 0)
  },
  methods: {
    goHome () {
      if (this.$route.name === 'Home') {
        location.reload()
      } else {
        this.$router.replace({ name: 'Home' })
      }
    },
    goAgreement (name) {
      this.$router.push({ name: 'agreement', query: { name } })
    }
  }

}
</script>

<style scoped lang="less">
.home {
  text-align: left;
}
.banner {
  width: 1100px;
  height: 100%;
  margin: auto;
}
.header {
  height: 660px;
  background-color: #272C2B;
  .banner {
    display: flex;
    justify-content: space-between;
  }
  .headerLeft {
    flex: 1;
    padding-top: 75px;
    .line {
      width: 176px;
      height: 1px;
      margin: 26px 0 41px;
      background-color: #F3F3F3;
    }
    ul {
      .title {
        display: flex;
        justify-content: space-between;
        color: #DDDDDD;
        padding-right: 60px;
        font-size: 24px;
        margin-bottom: 5px;
      }
      li {
        color: #D8D8D8;
        font-size: 14px;
        width: 420px;
        margin-bottom: 20px;
        text-align: left;
      }
    }
    .HeaderBottom {
      margin-top: 40px;
      display: flex;
      align-items: center;
      .botton {
        width: 270px;
        height: 60px;
        border-radius: 60px;
        text-align: center;
        line-height: 60px;
        background-color: #E7FE48;
        color: #000;
        font-size: 14px;
      }
      img {
        width: 108px;
        height: 34px;
        margin-right: 40px;
      }
    }
  }
  .headerRight {
    width: 600px;
    height: 625px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.introduce {
  background-color: #212121;
  height: 920px;
  h2 {
    width: 900px;
    font-size: 44px;
    color: #E0E0E0;
    padding: 65px 0;
    text-align: left;
  }
  ul {
    position: relative;
    .dashed {
      position: absolute;
      top: 60px;
      left: 30px;
      width: 0;
      height: 500px;
      border-left: 2px dashed #E7FE48;
      z-index: 1;
    }
    li {
      display: flex;
      color: #D8D8D8;
      font-size: 17px;
      margin-bottom: 77px;
      text-align: left;
       h4 {
        font-weight: 700;
      }
      img {
        width: 60px;
        height: 60px;
        margin-right: 50px;
        z-index: 2;
      }
    }
  }
}
.contact {
  height: 390px;
  background-color: #282c2b;
  padding-top: 56px;
  .content {
    width: 1127px;
    height: 288px;
    margin: auto;
    background-image: url('@/assets/home/联系方式背景图.png');
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 100px;
    .contactLeft {
      color: #FFFFFF;
      font-size: 45px;
      // width: 288px;
    }
    .contactRight {
      ul {
        display: flex;
        flex-wrap: wrap;
        width: 300px;
        li {
          text-align: left;
          display: flex;
          // width: 320px;
          width: 100%;
          height: 50px;
          color: #FFFFFF;
          font-size: 15px;
          // &:nth-child(1),
          &:nth-child(2) {
            margin-top: 44px;
          }
          h6 {
            font-size: 12px;
            margin-bottom: 10px;
          }
          img{
            width: 36px;
            height: 36px;
            margin-right: 15px;
          }
        }
      }
    }
  }
}
.footer {
  background-color: #000;
  color: #D8D8D8;
  .banner {
    display: flex;
    padding-top: 26px;
    .logo {
      height: 32px;
      display: flex;
      align-items: center;
      margin-right: 114px;
      color: #D8D8D8;
      img {
        width: 32px;
        height: 32px;
        margin-right: 5px;
      }
      span {
        font-size: 12px;
      }
    }
  }
  .address {
    text-align: left;
    h3 {
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 12px;
    }
    p {
      font-size: 12px;
    }
    a{
      margin: 16px 10px 30px 0;
      font-size: 12px;
      display: inline-block;
      border-bottom: 1px solid #D8D8D8;
      color: #fff;
    }
    .cancelBoutique {
      span {
        color: #E7FE48;
        font-size: 12px;
        border: 1px solid #E7FE48;
        border-radius: 21px;
        width: 200px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        margin-top: 20px;
        display: block;
      }
    }
  }
  .footerDownload {
    margin-left: 249px;
    a {
      display: block;
      width: 98px;
      height: 31px;
      &:last-child {
        margin-top: 20px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .bottom {
    border-top: 1px solid #434343;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 12px;
  }
}
</style>
